import BookDetails from './BookDetails';

export default BookDetails;
